import { render, staticRenderFns } from "./ticket-compliments.vue?vue&type=template&id=38b4581e&"
import script from "./ticket-compliments.vue?vue&type=script&lang=js&"
export * from "./ticket-compliments.vue?vue&type=script&lang=js&"
import style0 from "./ticket-compliments.vue?vue&type=style&index=0&id=38b4581e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports